import { render } from "./Emerchantpay.vue?vue&type=template&id=48c98d5a"
import script from "./Emerchantpay.vue?vue&type=script&lang=js"
export * from "./Emerchantpay.vue?vue&type=script&lang=js"

import exportComponent from "/home/smartphone/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__